import React, { Component } from "react";
import { 
    Table,
    OverlayTrigger,
    Tooltip,
    Row,
    Grid,
    Col,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import GovernmentLoanModal from "./GovernmentLoanModal";
import { editEmployeeRequest } from "../../api/employee";
import { formatPrice } from "../../helpers/functions/pricing";
import moment from "moment";

class GovernmentLoans extends Component  {

    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            modalType: null,
            error: null,
            governmentLoanData: {
                period: '',
                value: '',
                loanName: ''
            }
        }
    }

    handleGovernmentLoanModal = (type, data) => {

        this.setState({
            governmentLoanData: {},
            showModal: !this.state.showModal,
            modalType: type
        })
        if (type === "edit") {
            this.setState({
                governmentLoanData: data
            })
        }

    }

    deleteGovernmentLoan = async (employee, value) => {
        const { _id } = this.props.employee;
        let data = {
            governmentLoan : {
                delete: true,
                _id: value
            }
        };

        await editEmployeeRequest(employee, data);
        await this.props.fetchEmployee(_id);
    }

    handleGovernmentLoan = async (data) => {
        try {
            const {_id} = this.props.employee;

            const { entryType="Single", period, startPeriod, endPeriod, loanName, value } = data.governmentLoan;
            if(entryType === 'Single' && (!period || !value || !loanName)) {
                this.setState({
                    error: "All fields must be filled"
                });
                return;
            } else if(entryType === 'Multiple' && (!startPeriod || !endPeriod || !value || !loanName)) {
                this.setState({
                    error: "All fields must be filled"
                });
                return ;
            }

            const governmentLoan = this.normalizeGovernmentLoanPeriod(data.governmentLoan);
            await editEmployeeRequest(_id, { governmentLoan },
                result => this.saveSuccess(),
                error => this.saveFailure(error)
            );
            await this.props.fetchEmployee(_id)
            this.setState({
                showModal: false,
                error: false,
            })
        } catch (err) {
            console.log(err)
        }
    }

    normalizeGovernmentLoanPeriod = (governmentLoan) => {
        if (governmentLoan._id || governmentLoan.delete) {
            return governmentLoan;
        }

        if (governmentLoan.entryType === 'Single') {
            const periodDay = governmentLoan.periodDetails === 'SecondHalf' ? 16 : 1;
            return {
                ...governmentLoan,
                period: moment(governmentLoan.period).date(periodDay).format('YYYY-MM-DD')
            };
        }

        return {
            ...governmentLoan,
            startPeriod: moment(governmentLoan.startPeriod).startOf('month').format('YYYY-MM-DD'),
            endPeriod: moment(governmentLoan.endPeriod).startOf('month').format('YYYY-MM-DD')
        };
    }


    saveSuccess = () => {
        this.setState({ 
            error: null,
        });
    }
    
    saveFailure = (error) => {
        this.setState({ 
            error: error.message,
        })
    }


    render() {
        
        const {
            showModal,
            modalType,
            error,
            governmentLoanData
        } = this.state;

        const {
            readOnly,
            employee
        } = this.props;


        // const view = <Tooltip id="view_tooltip">View</Tooltip>;
        const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
        const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

        return (
            <div cclassName="content">
                <Grid fluid>
                    <Row>
                        <Col md={12} className="p-0">
                            <Card
                                title="Government Loans"
                                category="Values will be used for payroll calculation if present"
                                ctTableFullWidth
                                ctTableResponsive
                                content={
                                    <div>
                                        <CustomButtom className={readOnly ? "d-none table-top-btn btn-primary" : "table-top-btn btn btn-primary"} onClick={() => this.handleGovernmentLoanModal("create")}>
                                            New Entry
                                        </CustomButtom>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Period</th>
                                                    <th>Value</th>
                                                    <th>Loan Name</th>
                                                    <th>Provider</th>
                                                    <th  className={readOnly ? "d-none td-actions text-right" : "td-actions text-right"}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {this.props.loading ?
                                                <td colSpan="3" style={{padding: "0"}}>
                                                    <div className="loader"></div>
                                                </td> 
                                            :
                                                (employee.governmentLoans && employee.governmentLoans.length > 0) ?
                                                employee.governmentLoans.map((item) => (
                                                    <tr key={item._id}>
                                                        <td>{`${moment.utc(item.period).format('MMMM/yyyy')} - ${moment.utc(item.period).format('DD') === '16'  ? 'Second half' : 'First half'}` || "N/A"}</td>
                                                        <td>{item.value ? `PHP ${formatPrice(item.value)}`: "N/A"}</td>
                                                        <td>{item.loanName || "N/A"}</td>
                                                        <td>{item.provider || "N/A"}</td>
                                                        <td className={readOnly ? "d-none td-actions text-right" : "td-actions text-right"}>
                                                            <OverlayTrigger placement="top" overlay={edit}>
                                                            <CustomButtom 
                                                                bsStyle="info" 
                                                                simple 
                                                                type="button" 
                                                                bsSize="xs"
                                                                onClick={() => this.handleGovernmentLoanModal("edit", item)}
                                                            >
                                                                <i className="fa fa-edit" />
                                                            </CustomButtom>
                                                            </OverlayTrigger>

                                                            <OverlayTrigger placement="top" overlay={remove}>
                                                            <CustomButtom 
                                                                bsStyle="danger" 
                                                                simple 
                                                                type="button" 
                                                                bsSize="xs"
                                                                onClick={() => this.deleteGovernmentLoan(employee._id, item._id)}
                                                            >
                                                                <i className="fa fa-times" />
                                                            </CustomButtom>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                ))
                                                :
                                                <tr>
                                                    <td colSpan='5'>There are no custom values in the database yet.</td>
                                                </tr>
                                            }
                                            
                                    
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
                <GovernmentLoanModal 
                    governmentLoanData={governmentLoanData}
                    showModal={showModal}
                    closeModal={this.handleGovernmentLoanModal}
                    modalType={modalType}
                    handleGovernmentLoan={this.handleGovernmentLoan}
                    error={error}
                />
            </div>
        )
    }
}

export default GovernmentLoans;
